<template>
  <div class="progress-container">
    <div class="progress-wrap">
      <div class="progressBar">
        <progressBar :current="currentStep" />
      </div>
      <div class="infoTab">
        <div
          v-for="item in infoTabList"
          :key="item.id"
          class="tabItem"
          :class="{ active: item.id == currentStep }"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { infoTabList } from "@/utils/const.js";
import progressBar from "@/components/progressBar/rogressBar.vue";
export default {
  name: "Progress",
  components: {
    progressBar,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      infoTabList,
    };
  },
  computed: {
    fillWidth() {
      // 1步时进度为0%；2步时进度走一半(50%)；3步时全部高亮(100%)
      if (this.currentStep == 1) return 10;
      if (this.currentStep == 2) return 50;
      if (this.currentStep == 3) return 94;
      return 0;
    },
  },
};
</script>
<style scoped lang="scss">
.progress-container {
  position: fixed;
  top: calc(56px + constant(safe-area-inset-top, 0px));
  top: calc(56px + env(safe-area-inset-top, 0px));
  left: 0px;
  width: 100%;
  z-index: 99;
  background: #f5f5f5;
}
.progress-wrap{
  padding: 14px 16px 11px 16px;
  background: #fff;
  box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.05);
  border-radius: 10px;
  margin: 16px;
}
.infoTab {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  .tabItem {
    font-size: 13px;
    color: #777777;
    flex: 1;
  }
  .tabItem:nth-child(3) {
    text-align: right;
  }
  .tabItem:nth-child(2) {
    text-align: center;
  }
  .tabItem.active {
    color: #333333;
  }
}
</style>
